namespace $ {

	export class $mol_data_error extends $mol_error_mix {}

}
